import { render, staticRenderFns } from "./KnowledgeList.vue?vue&type=template&id=d7c1c32a&scoped=true&lang=pug"
import script from "./KnowledgeList.vue?vue&type=script&lang=js"
export * from "./KnowledgeList.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeList.vue?vue&type=style&index=0&id=d7c1c32a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c1c32a",
  null
  
)

export default component.exports